module.exports = __webpack_public_path__ + "img/204.4849b18b.jpg";